<template>
  <div class="scientific-article">
    <a id="viber_share" style="display: none;" href=""></a>


    <author-popup @closePopup="closePopup()" :currentVideoTitle="articleItem.title" :authorInfo="authorInfo" v-if="isAuthorInfoOpen"/>
    <product-popup @closePopup="closePopup()" :productInfo="productInfo" v-if="isProductInfoOpen"/>

    <language-popup @closePopup="closePopup()" :action="action" v-if="action" :contentUa="articleItem"
                    :contentRu="articleItem" :contentEn="articleItem"/>

    <div class="article-header">
      <div class="article-type">Відеоматеріал</div>
    </div>

    <div class="article-content">

      <div class="article-title">
        <div class="title">
          {{ articleItem.title }}
        </div>
        <div class="content">

          <div class="video-container">
            <iframe v-if="langActive === 'ukr'" :src="articleItem.linkUa"
                    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            <iframe v-if="langActive === 'ru'" :src="articleItem.linkRu"
                    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            <iframe v-if="langActive === 'en'" :src="articleItem.linkEn"
                    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
          </div>

          <div class="lang-swiper">
            <div class="ukr" :class="langActive === 'ukr' ? 'active' : ''" @click="langActive = 'ukr'" v-if="articleItem.linkUa">
              Українська
            </div>
            <div class="ru" :class="langActive === 'ru' ? 'active' : ''" @click="langActive = 'ru'" v-if="articleItem.linkRu">
              Русский
            </div>
            <div class="en" :class="langActive === 'en' ? 'active' : ''" @click="langActive = 'en'" v-if="articleItem.linkEn">
              English
            </div>
          </div>
        </div>

      </div>

      <div class="author">
        <div class="icon">
          <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.57171 8C8.62306 8 10.286 6.433 10.286 4.5C10.286 2.567 8.62306 1 6.57171 1C4.52037 1 2.85742 2.567 2.85742 4.5C2.85742 6.433 4.52037 8 6.57171 8Z" stroke="#8F67A4" stroke-width="0.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6.57143 8C9.64856 8 12.1429 10.6862 12.1429 14H1C1 11.915 1.98571 10.0803 3.4828 9.00481" stroke="#8F67A4" stroke-width="0.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="authors-items">
          <div class="item" v-for="(author, index) in articleItem.authors" :key="index" @click="openAuthorInfo(author)">
            {{ getShortName(author.name) }}
          </div>
        </div>
      </div>

      <div class="year-block">
        <div class="icon">
          <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.45 4.97982V14.4588H1.55V4.97982H13.45ZM13.75 1.93246H12.55V1.24561C12.55 1.08134 12.415 0.95 12.25 0.95H10.5C10.335 0.95 10.2 1.08134 10.2 1.24561V1.93246H4.8V1.24561C4.8 1.08134 4.66503 0.95 4.5 0.95H2.75C2.58497 0.95 2.45 1.08134 2.45 1.24561V1.93246H1.25C1.08497 1.93246 0.95 2.0638 0.95 2.22807V4.68421V15V15.05H1H1.00001H1.00002H1.00003H1.00005H1.00006H1.00008H1.0001H1.00013H1.00015H1.00018H1.00021H1.00025H1.00029H1.00032H1.00037H1.00041H1.00046H1.00051H1.00056H1.00061H1.00067H1.00073H1.00079H1.00085H1.00092H1.00099H1.00106H1.00113H1.00121H1.00129H1.00137H1.00145H1.00154H1.00163H1.00172H1.00181H1.00191H1.00201H1.00211H1.00221H1.00231H1.00242H1.00253H1.00264H1.00276H1.00288H1.003H1.00312H1.00324H1.00337H1.0035H1.00363H1.00376H1.0039H1.00404H1.00418H1.00432H1.00447H1.00461H1.00476H1.00492H1.00507H1.00523H1.00539H1.00555H1.00571H1.00588H1.00605H1.00622H1.00639H1.00657H1.00675H1.00693H1.00711H1.00729H1.00748H1.00767H1.00786H1.00805H1.00825H1.00845H1.00865H1.00885H1.00905H1.00926H1.00947H1.00968H1.0099H1.01011H1.01033H1.01055H1.01077H1.011H1.01122H1.01145H1.01168H1.01192H1.01215H1.01239H1.01263H1.01287H1.01312H1.01336H1.01361H1.01386H1.01412H1.01437H1.01463H1.01489H1.01515H1.01541H1.01568H1.01595H1.01622H1.01649H1.01676H1.01704H1.01732H1.0176H1.01788H1.01817H1.01845H1.01874H1.01903H1.01933H1.01962H1.01992H1.02022H1.02052H1.02082H1.02113H1.02144H1.02174H1.02206H1.02237H1.02269H1.023H1.02332H1.02364H1.02397H1.02429H1.02462H1.02495H1.02528H1.02562H1.02595H1.02629H1.02663H1.02697H1.02732H1.02766H1.02801H1.02836H1.02871H1.02907H1.02942H1.02978H1.03014H1.0305H1.03086H1.03123H1.0316H1.03196H1.03234H1.03271H1.03308H1.03346H1.03384H1.03422H1.0346H1.03499H1.03537H1.03576H1.03615H1.03654H1.03694H1.03733H1.03773H1.03813H1.03853H1.03894H1.03934H1.03975H1.04016H1.04057H1.04098H1.04139H1.04181H1.04223H1.04265H1.04307H1.04349H1.04392H1.04435H1.04478H1.04521H1.04564H1.04607H1.04651H1.04695H1.04739H1.04783H1.04827H1.04872H1.04916H1.04961H1.05006H1.05052H1.05097H1.05143H1.05188H1.05234H1.0528H1.05327H1.05373H1.0542H1.05466H1.05513H1.05561H1.05608H1.05655H1.05703H1.05751H1.05799H1.05847H1.05895H1.05944H1.05992H1.06041H1.0609H1.06139H1.06189H1.06238H1.06288H1.06338H1.06388H1.06438H1.06488H1.06539H1.06589H1.0664H1.06691H1.06742H1.06794H1.06845H1.06897H1.06949H1.07001H1.07053H1.07105H1.07157H1.0721H1.07263H1.07316H1.07369H1.07422H1.07475H1.07529H1.07583H1.07636H1.0769H1.07745H1.07799H1.07853H1.07908H1.07963H1.08018H1.08073H1.08128H1.08183H1.08239H1.08295H1.08351H1.08407H1.08463H1.08519H1.08575H1.08632H1.08689H1.08746H1.08803H1.0886H1.08917H1.08975H1.09032H1.0909H1.09148H1.09206H1.09264H1.09323H1.09381H1.0944H1.09499H1.09558H1.09617H1.09676H1.09735H1.09795H1.09855H1.09914H1.09974H1.10034H1.10095H1.10155H1.10215H1.10276H1.10337H1.10398H1.10459H1.1052H1.10581H1.10643H1.10704H1.10766H1.10828H1.1089H1.10952H1.11014H1.11077H1.11139H1.11202H1.11265H1.11328H1.11391H1.11454H1.11517H1.11581H1.11644H1.11708H1.11772H1.11836H1.119H1.11964H1.12029H1.12093H1.12158H1.12223H1.12287H1.12352H1.12418H1.12483H1.12548H1.12614H1.12679H1.12745H1.12811H1.12877H1.12943H1.13009H1.13076H1.13142H1.13209H1.13275H1.13342H1.13409H1.13476H1.13544H1.13611H1.13678H1.13746H1.13814H1.13881H1.13949H1.14017H1.14085H1.14154H1.14222H1.14291H1.14359H1.14428H1.14497H1.14566H1.14635H1.14704H1.14773H1.14843H1.14912H1.14982H1.15051H1.15121H1.15191H1.15261H1.15332H1.15402H1.15472H1.15543H1.15613H1.15684H1.15755H1.15826H1.15897H1.15968H1.16039H1.16111H1.16182H1.16254H1.16325H1.16397H1.16469H1.16541H1.16613H1.16685H1.16757H1.1683H1.16902H1.16975H1.17048H1.1712H1.17193H1.17266H1.17339H1.17412H1.17486H1.17559H1.17633H1.17706H1.1778H1.17854H1.17927H1.18001H1.18075H1.1815H1.18224H1.18298H1.18373H1.18447H1.18522H1.18596H1.18671H1.18746H1.18821H1.18896H1.18971H1.19047H1.19122H1.19197H1.19273H1.19349H1.19424H1.195H1.19576H1.19652H1.19728H1.19804H1.1988H1.19956H1.20033H1.20109H1.20186H1.20263H1.20339H1.20416H1.20493H1.2057H1.20647H1.20724H1.20801H1.20879H1.20956H1.21033H1.21111H1.21189H1.21266H1.21344H1.21422H1.215H1.21578H1.21656H1.21734H1.21812H1.21891H1.21969H1.22048H1.22126H1.22205H1.22283H1.22362H1.22441H1.2252H1.22599H1.22678H1.22757H1.22836H1.22915H1.22995H1.23074H1.23154H1.23233H1.23313H1.23393H1.23472H1.23552H1.23632H1.23712H1.23792H1.23872H1.23952H1.24032H1.24113H1.24193H1.24273H1.24354H1.24434H1.24515H1.24596H1.24676H1.24757H1.24838H1.24919H1.25L13.9151 15.05L13.9867 15.1304L13.9872 15.05H14.049L13.9876 14.9811L14.05 4.68451V4.68421V2.22807C14.05 2.0638 13.915 1.93246 13.75 1.93246ZM10.8 2.22807V1.54123H11.95V2.22807V2.91491H10.8V2.22807ZM3.05 2.22807V1.54123H4.2V2.22807V2.91491H3.05V2.22807ZM1.55 2.52368H2.45V3.21052C2.45 3.37479 2.58497 3.50614 2.75 3.50614H4.5C4.66503 3.50614 4.8 3.37479 4.8 3.21052V2.52368H10.2V3.21052C10.2 3.37479 10.335 3.50614 10.5 3.50614H12.25C12.415 3.50614 12.55 3.37479 12.55 3.21052V2.52368H13.45V4.38859H1.55V2.52368Z" fill="#8F67A4" stroke="#8F67A4" stroke-width="0.1"/>
          </svg>
        </div>
        <div class="year">
          {{ articleItem.publishYear }}
        </div>
      </div>

      <div class="points">
        <div class="anotation item">

          <div class="title" @click="isAnotationOpen = !isAnotationOpen">
            <div class="text">
              Анотація
            </div>
            <div class="open">
              <div class="line" :class="isAnotationOpen ? '': 'rotated'"></div>
              <div class="line"></div>
            </div>
          </div>

          <transition name="fade">
            <div class="container" v-if="isAnotationOpen">
              {{ articleItem.annotation }}
            </div>
          </transition>

        </div>

        <div class="key-words item" v-if="articleItem.tags.length > 0">

          <div class="title" @click="isKeyWordsOpen = !isKeyWordsOpen">
            <div class="text">
              Ключові слова
            </div>
            <div class="open">
              <div class="line" :class="isKeyWordsOpen ? '': 'rotated'"></div>
              <div class="line"></div>
            </div>
          </div>

          <transition name="fade">
            <div class="container" v-if="isKeyWordsOpen">
              <div v-for="(tag, index) in articleItem.tags" :key="index">
                  {{tag.title}}<span v-if="index !== articleItem.tags.length - 1">,&nbsp;</span>
              </div>
              <!-- <div v-for="(word, index) in getProductTags()" :key="index">
                {{ word.title }}<span v-if="index !== getProductTags().length - 1">,&nbsp;</span>
              </div> -->
            </div>
          </transition>

        </div>

        <div class="products item" v-if="articleItem.products.length > 0">

          <div class="title" @click="isProductsOpen = !isProductsOpen">
            <div class="text">
              Згадані продукти
            </div>
            <div class="open">
              <div class="line" :class="isProductsOpen ? '': 'rotated'"></div>
              <div class="line"></div>
            </div>
          </div>

          <transition name="fade">
            <div class="container" v-if="isProductsOpen">
              <div class="product-label" v-for="(product, index) in articleItem.products" :key="index"
                   @click="openProductInfoPopup(product)">
                {{ product.title }}
              </div>
            </div>
          </transition>

        </div>
      </div>

      <div class="actions-block">
        <div class="send" @click="openLanguagePopup('send')">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.0315 9.02942L17.0622 8.99573L17.0315 8.96204L9.7397 0.966308L9.65276 0.87097V1V5.73955H8.85571C6.74419 5.73955 4.75869 6.56196 3.26555 8.0551C1.77241 9.54824 0.95 11.5337 0.95 13.6454V17V17.129L1.03693 17.0337L2.43635 15.5004C4.28757 13.4722 6.91073 12.2937 9.65276 12.253V16.9916V17.1206L9.7397 17.0253L17.0315 9.02942ZM15.658 8.99573L10.6903 14.443V11.2644V11.2144H10.6403H9.79907C6.86704 11.2144 4.04602 12.3946 1.98762 14.4673V13.6454C1.98762 11.8107 2.70196 10.086 3.99922 8.78877C5.29649 7.49151 7.02107 6.77717 8.85571 6.77717H10.6403H10.6903V6.72717V3.54858L15.658 8.99573Z" fill="#8F67A4" stroke="#8F67A4" stroke-width="0.1"/>
          </svg>
          надіслати
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import AuthorPopup from '../library-items/popups/author-popup';
import ProductPopup from '../library-items/popups/product-popup';
import LanguagePopup from '../library-items/popups/language-popup';

export default {
  props: ['articleItem'],
  components: {
    'author-popup': AuthorPopup,
    'product-popup': ProductPopup,
    'language-popup': LanguagePopup
  },
  created(){
        this.articleItem.products.sort((a, b) => {
            if(a.position < b.position) { return -1; }
            if(a.position > b.position) { return 1; }
            return 0;
        })
    },
  data: () => ({
    action: "",
    langActive: 'ukr',
    isAnotationOpen: false,
    isKeyWordsOpen: false,
    isProductsOpen: false,
    isAlgorithmsOpen: false,

    isAuthorInfoOpen: false,
    isProductInfoOpen: false,

    authorInfo: {},
    authorTestInfo: {
      fullName: 'Дмитро Олександрович Добрянський',
      awards: 'д.м.н., професор кафедри педіатрії №2 Львівського національного медичного університету ім. Данила Галицького',
      email: 'dobryanskiy@gmail.com',
      materials: [
        {
          id: 2,
          them: 'Використання білкової добавки для забезпечення харчових потреб значно недоношених дітей',
          subtitle: 'Відеоматеріал, 2020'
        },
        {
          id: 3,
          them: 'Харчова алергія на білок коров’ячого молока чи непереносимість лактози? Принципи диференціальної діагностики й дієтотерапії',
          subtitle: 'Здоров’я дитини. – 2019. – №3'
        },
        {
          id: 3,
          them: 'Харчова алергія на білок коров’ячого молока чи непереносимість лактози? Принципи диференціальної діагностики й дієтотерапії',
          subtitle: 'Здоров’я дитини. – 2019. – №3'
        },
        {
          id: 3,
          them: 'Харчова алергія на білок коров’ячого молока чи непереносимість лактози? Принципи диференціальної діагностики й дієтотерапії',
          subtitle: 'Здоров’я дитини. – 2019. – №3'
        },
      ]
    },

    productInfo: {},
    productTestInfo: {
      name: 'Суміш суха Nutrilon Пепті',
      description: 'комплексне рішення при харчовій алергії на білок коров’ячого молока',
      useFor: 'Алергія на БКМ',
      image: ''
    },
  }),
  mounted(){
        const UNAUTHORIZED = 401;
          axios.interceptors.response.use(
            response => response,
            error => {
              const {status} = error.response;
              if (status === UNAUTHORIZED) {
                sessionStorage.removeItem('key');
              }
              return Promise.reject(error);
            }
          );
    },
  methods: {
    openLanguagePopup(action){
            if(this.articleItem.linkRu || this.articleItem.linkEn){
                this.action = action;
                this.removeScroll();
            }
            else{
              document
              .getElementById("viber_share")
              .setAttribute(
                  "href",
                  "https://3p3x.adj.st/?adjust_t=u783g1_kw9yml&adjust_fallback=https%3A%2F%2Fwww.viber.com%2F%3Futm_source%3DPartner%26utm_medium%3DSharebutton%26utm_campaign%3DDefualt&adjust_campaign=Sharebutton&adjust_deeplink=" +
                  encodeURIComponent(
                      "viber://forward?text=" +
                      encodeURIComponent(this.articleItem.linkUa)
                  )
              );
              document.getElementById("viber_share").click();
            }
        },

    getShortName(name) {
      name = name.split(" ");
      return name[0].substring(0, 1) + '.' + name[1].substring(0, 1) + '. ' + name[2];
    },
    getProductTags() {
      let tags = [];

      for (let i = 0; i < this.articleItem.products.length; i++) {
        tags = tags.concat(this.articleItem.products[i].tags)
      }

      return tags;
    },
    openAuthorInfo(author){            
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem("key");

        axios.post(this.$root.globalUrl + "api/v1/library-clinical/author/" + author.id)
        .then(res => {

            this.removeScroll();

            this.authorInfo = res.data.data;

            this.isAuthorInfoOpen = true;
            
        })
    },
    openProductInfoPopup(product) {

      this.removeScroll();

      this.productInfo = product;

      this.isProductInfoOpen = true;
    },
    closePopup() {

      this.action = '';
      this.isAuthorInfoOpen = false;
      this.isProductInfoOpen = false;
      this.addScroll();
    },
    removeScroll() {
      if(window.screen.width > 426){
        document.getElementsByTagName("body")[0].style.overflow = "visible";
      }
      else{
        document.getElementsByTagName("body")[0].style.overflow = "hidden";
      }
    },
    addScroll() {
      document.getElementsByTagName("body")[0].style.overflow = "visible";
    }
  }
}
</script>

<style lang="scss" scoped>
.scientific-article {
  padding: 15px 15px 60px;
  border-radius: 4px;

  .video-container {
    position: relative;
    width: 100%;
    overflow: hidden;
    padding-top: 56.25%; /* 16:9 Aspect Ratio */
    margin: 10px 0;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
      border: none;
    }
  }

  .article-header {
    background: #EFE1F7;
    padding: 10px 15px 15px 15px;

    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .article-type {
      font-size: 12px;
      color: #4A2A80;
    }
  }

  .article-content {
    background: #FFFFFF;

    .article-title {
      padding: 20px 15px;

      border-bottom: 1px solid #EFE1F7;

      .title {
        font-weight: 600;
        font-size: 13px;
        line-height: 130%;
        color: #4A2A80;
      }

      .content {
        display: flex;
        flex-direction: column;

        video {
          width: 100%;
          margin-bottom: 3px;
        }

        .lang-swiper {
          display: flex;
          flex-direction: row;
          cursor: pointer;

          .ukr, .ru, .en {
            flex-grow: 1;
            flex-basis: 0;

            font-size: 12px;
            text-transform: uppercase;
            color: #4A2A80;

            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            height: 35px;

            border: 1px solid #EFE1F7;
            box-sizing: border-box;

            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;

            cursor: pointer;
          }

          .active {
            font-weight: 600;
            background: #EFE1F7;
          }
        }
      }

    }

    .author {
      padding: 20px 5px 10px 16px;

      display: flex;
      flex-direction: row;

      .icon {
        padding-right: 9px;
      }

      .authors-items {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        font-size: 10px;
        color: #4A2A80;

        .item {
          padding: 4px 4px;
          border: 0.606867px solid #AC98C5;
          box-sizing: border-box;
          border-radius: 4px;
          cursor: pointer;

          margin-right: 5px;
        }
      }
    }

    .year-block {
      padding: 5px 5px 25px 16px;

      display: flex;
      flex-direction: row;
      align-items: center;

      border-bottom: 1px solid #DAE3ED;

      .icon {
        margin-right: 8px;

        display: flex;
        align-items: center;
      }

      .year {
        color: #4A2A80;
        font-size: 10px;
        line-height: 14px;
      }
    }

    .points {
      .item {
        padding: 13px 20px 17px 15px;

        border-bottom: 1px solid #DAE3ED;
        cursor: pointer;

        .title {
          font-weight: 600;
          font-size: 14px;
          color: #4A2A80;

          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;

          .open {
            width: 20px;
            height: 20px;

            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;

            .line {
              width: 100%;
              height: 2px;
              background: #8F67A4;

              position: absolute;
              transition: transform 500ms ease;
            }

            .rotated {
              transform: rotate(-90deg);
              transition: transform 500ms ease;
            }
          }
        }

        .container {
          padding-top: 10px;

          font-size: 12px;
          color: #4A2A80;
          font-weight: 300;
          line-height: 135%;
        }

      }

      .key-words, .products {
        .container {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
        }
      }

      .products {
        .container {
          padding-top: 20px;

          .product-label {
            display: flex;

            margin-right: 10px;
            margin-bottom: 10px;

            padding: 4px 4px;
            border: 0.606867px solid #AC98C5;
            box-sizing: border-box;
            border-radius: 4px;
          }
        }
      }
    }

    .actions-block {
      padding: 30px 15px;

      .send {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        padding: 11px 0;

        border: 1px solid #8F67A4;
        box-sizing: border-box;
        border-radius: 4px;

        color: #8F67A4;
        text-transform: uppercase;
        font-weight: bold;
        cursor: pointer;

        svg {
          margin-right: 9px;
        }
      }
    }
  }


}
</style>
